<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4SSqGE/tc-custom/9780795351204.jpg?1702553743522" alt="This image is the cover for the book Sleep of Baby Filbertson"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sleep of Baby Filbertson
      </h1>
      <p class="bookDescription body article font2">
        <b>This short story collection by the acclaimed author of <i>Midnight Cowboy </i>explores the desperate lives of outsiders with unflinching insight.</b><br/>  <br/> In his first collection of short fiction, James Leo Herlihy examines the experiences of alienation and isolation while elevating the oddities and quirks that make up human nature. These seven tales tackle the anxieties of fragile people and get to the heart of a world inhabited by perennial outsiders.<br/><br/> Agoraphobic Daisy Filbertson and her teenage son Rudy, both addicted to sleeping pills, find themselves frantically running from city to city fueled by Daisy’s manic paranoia. A lonely mother looking to start her life over finds a new father for her daughter on an Army base. An immigrant from Uruguay writes letters to his Mamacita while he tries to find himself in the US. And a staunch Baptist has her world challenged when she meets a handsome artist.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Leo Herlihy
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      RosettaBooks 
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e2e79e32